import React from 'react';
import { Table, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import UserSider from '../UserSider';
import Filter from './Filter';
import '../css/style.less';

class UserPlan extends React.Component {
    state = {
        sortParams: {},
        searchParams: {},
        invSortParams: {},
        invSearchParams: {},
        data: [],
        subData: {},
        pagination: {
            pageSize: 10,
            current: 1,
        }, 
        loading: false,
        invLoading: false,
        expandedRowKeys: [],
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        this.setState({
            loading: true,
            expandedRowKeys: [],
         });
        const options = {
            method: 'POST',
            url: API_URL.user.queryEmployeeForArrange,
            data: {
                ...sortParams,
                ...searchParams,
                offset: pagination.current,
                limit: pagination.pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const pagination = { ...this.state.pagination };
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            }
        }
        $.sendRequest(options)
    }

    loadInvData = () => {
        const { subData, searchParams, invSortParams, invSearchParams } = this.state;
        this.setState({ invLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryEmployeeArrangeById,
            data: {
                ...searchParams,
                ...invSearchParams,
                ...invSortParams,
            },
            dataType: 'json',
            doneResult: res => {
                subData[invSearchParams.key] = res.data;
                this.setState({
                    subData,
                    invLoading: false,
                });
            }
        }
        $.sendRequest(options)
    }

    getColumns = () => {
        const { data, expandedRowKeys } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 140,
            fixed: expandedRowKeys.length > 0 ? null : 'left',
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 140,
            fixed: expandedRowKeys.length > 0 ? null : 'left',
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 160,
            fixed: expandedRowKeys.length > 0 ? null : 'left',
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 160,
        }, {
            title: '省',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 160,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 160,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderEmployeeCode',
            key: 'leaderEmployeeCode',
            width: 160,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderCompellation',
            key: 'leaderCompellation',
            width: 160,
        }, {
            title: '参与项目数量',
            dataIndex: 'invNum',
            key: 'invNum',
            width: 160,
            render: text => text || 0
        }, {
            title: '进行中项目数量',
            dataIndex: 'invUnderwayNum',
            key: 'invUnderwayNum',
            width: 160,
            render: text => text || 0
        }, {
            title: '参与项目医院数',
            dataIndex: 'hosInvNum',
            key: 'hosInvNum',
            width: 160,
            render: text => text || 0
        }, {
            title: '进行中项目医院数',
            dataIndex: 'hosInvUnderwayNum',
            key: 'hosInvUnderwayNum',
            width: 160,
            render: text => text || 0
        }, {
            title: '休假情况',
            dataIndex: 'userVacate',
            key: 'userVacate',
            width: 200,
            render: (text, record) => {
                return text;
            }
        }, {
            title: '累计FTE',
            dataIndex: 'fteTotal',
            key: 'fteTotal',
            width: 180,
            render: text => text || 0
        }, {
            title: '上月FTE',
            dataIndex: 'lastMonthFte',
            key: 'lastMonthFte',
            width: 180,
            render: text => text || 0
            
        }, {
            title: '当月FTE',
            dataIndex: 'thisMonthFte',
            key: 'thisMonthFte',
            width: 180,
            render: text => text || 0
        }];

        if (data.length > 0) {
            if (data[0].userPlans && data[0].userPlans.length > 0) {
                data[0].userPlans.map( (item, index) => {
                    columns.push({
                        title: `${item.year}.${item.month}`,
                        children: [{
                            title: '已分配',
                            dataIndex: 'planFte' + index,
                            key: 'planFte' + index,
                            width: 60,
                            render: text => text || 0,
                        }, {
                            title: '预分配',
                            dataIndex: 'prospectiveFte' + index,
                            key: 'prospectiveFte' + index,
                            width: 60,
                            render: text => text || 0,
                        }],
                    })
                })
            }
        }
        return columns;
    }

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;

        if (data.length > 0) {
            data.map((item, index) => {
                const addData = {};
                if (item.userPlans && item.userPlans.length > 0) {
                    item.userPlans.map((planItem, planIndex) => {
                        addData['planFte' + planIndex] = planItem.planFte;
                        addData['prospectiveFte' + planIndex] = planItem.prospectiveFte;
                    })
                }
                let node = null;
                if (item.vacationValue != null) {
                    const list = item.vacationValue.split(',');
                    node = list.map(listItem => (
                        <span>{listItem};<br/></span>
                    ))
                }
                dataSource.push({
                    key: index + 1,
                    ...item,
                    ...addData,
                    vacationValue: node,
                });
            });
        }
        return dataSource;
    }

    search = params => {
        const { searchParams, pagination }  = this.state;
        pagination.current = 1;

        this.setState({
            searchParams: {
                ...searchParams,
                ...params,
            },
            pagination,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams, pagination = {} } = this.state;
        let url = API_URL.user.exportEmployeeForArrange;
        this.addToDownloadSite(searchParams, pagination, url);
    }

    addToDownloadSite = (params, pagination, url) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type: 'EMPLOYEE_ARRANGE' },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                ExportUtil.export({ ...params, asynchronousExportId }, pagination, url);
            },
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    handleInvTableChange = (pagination, filters, sorter) => {
        const { invSortParams } = this.state;
        invSortParams.sort = sorter.field ;
        invSortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            invSortParams,
        }, () => {
            this.loadInvData();
        });
    }

    onExpand = (expanded, record) => {
        const { invSearchParams, expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            invSearchParams.key = record.key;
            invSearchParams._userId = record.userId;
            this.setState({
                invSearchParams,
            }, () => {
                this.loadInvData();
            })
        }
    }

    getRender = (type, options) => {
        if (type === 'split') {
            // 文本换行
            const { num, showText = true } = options;
            return (text, record) => {
                const arr  = text ? text.split(',') : [];
                const len = arr.length;
                const res = arr.map((item, index) => {
                    if ((index + 1) % num == 0) {
                        return <span>{item}{(len - 1 === index) ? '' : ','}&nbsp;&nbsp;<br /></span>;
                    } else {
                        return `${item}${(len - 1 === index) ? '' : ','}`;
                    }
                });
                if (!showText) {
                    const { roleCode } = record;
                    return (
                        (roleCode === 'PA' || roleCode === 'PM') ? '-' : res
                    );
                } else {
                    return res;
                }
            }
        } else if (type === '-') {
            return (text, record) => {
                const { roleCode } = record;
                const { noData } = options || {};
                return (
                    (roleCode === 'PA' || roleCode === 'PM') ? '-' : text || (noData === undefined ? '' : noData)
                );
            }
        }
    }

    expandedRowRender = (record) => {
        const { subData, invLoading } = this.state;
        const invList = subData[record.key] || [];

        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 100,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 90,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 80,
            }, {
                title: '领域leader',
                dataIndex: 'leaderNameCode',
                key: 'leaderNameCode',
                width: 100,
            }, {
                title: '申办方',
                dataIndex: 'investigationSponsor',
                key: 'investigationSponsor',
                width: 80,
            }, {
                title: 'CRO',
                dataIndex: 'cro',
                key: 'cro',
                width: 80,
            }, {
                title: '项目分期',
                dataIndex: 'investigationByStageName',
                key: 'investigationByStageName',
                width: 80,
            }, {
                title: '项目分类',
                dataIndex: 'typeName',
                key: 'typeName',
                width: 80,
            }, {
                title: '项目中承担的角色',
                dataIndex: 'roleCode',
                key: 'roleCode',
                width: 70,
            }, {
                title: '项目阶段',
                dataIndex: 'stageNameShow',
                key: 'stageNameShow',
                width: 80,
            }, {
                title: 'PM工号',
                dataIndex: 'pmEmployeeCodes',
                key: 'pmEmployeeCodes',
                width: 120,
                render: this.getRender('split', { num: 2 }),
            }, {
                title: 'PM姓名',
                dataIndex: 'pmUserNames',
                key: 'pmUserNames',
                width: 120,
                render: this.getRender('split', { num: 2 }),
            }, {
                title: '区域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 60,
            }, {
                title: '城市',
                dataIndex: 'cityName',
                key: 'cityName',
                width: 60,
            }, {
                title: '县级行政区（如无则默认为上级行政单位）',
                dataIndex: 'countyName',
                key: 'countyName',
                width: 100,
            }, {
                title: '医院',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 90,
                render: this.getRender('-'),
            }, {
                title: '院区',
                dataIndex: 'courtyardArea',
                key: 'courtyardArea',
                width: 60,
            }, {
                title: '科室',
                dataIndex: 'departmentName',
                key: 'departmentName',
                width: 90,
                render: this.getRender('-'),
            }, {
                title: 'PI',
                dataIndex: 'pi',
                key: 'pi',
                width: 120,
                render: this.getRender('split', { num: 2, showText: false }),
            }, {
                title: '中心启动时间',
                dataIndex: 'startTime',
                key: 'startTime',
                width: 100,
                render: this.getRender('-'),
            }, {
                title: '在组患者数',
                dataIndex: 'patientsInProgressNum',
                key: 'patientsInProgressNum',
                width: 80,
                render: this.getRender('-', { noData: 0 }),
            }, {
                title: '总筛选数',
                dataIndex: 'filterNum',
                key: 'filterNum',
                width: 80,
                render: this.getRender('-', { noData: 0 }),
            }, {
                title: '总入组数',
                dataIndex: 'randomNum',
                key: 'randomNum',
                width: 80,
                render: this.getRender('-', { noData: 0 }),
            }, {
                title: '上月筛选数',
                dataIndex: 'lastFilterNum',
                key: 'lastFilterNum',
                width: 80,
                render: this.getRender('-', { noData: 0 }),
            }, {
                title: '上月入组数',
                dataIndex: 'lastRandomNum',
                key: 'lastRandomNum',
                width: 80,
                render: this.getRender('-', { noData: 0 }),
            }, {
                title: '累计FTE',
                dataIndex: 'fteTotal',
                key: 'fteTotal',
                sorter: true,
                width: 80,
                render: text => text || 0,
            }, {
                title: '上月FTE',
                dataIndex: 'lastMonthFte',
                key: 'lastMonthFte',
                sorter: true,
                width: 80,
                render: text => text || 0,
            }, {
                title: '当月FTE',
                dataIndex: 'thisMonthFte',
                key: 'thisMonthFte',
                sorter: true,
                width: 80,
                render: text => text || 0,
            }];
            if (invList && invList.length > 0) {
                if (invList[0].userInvPlans && invList[0].userInvPlans.length > 0) {
                    invList[0].userInvPlans.map( (item, index) => {
                        columns.push({
                            title: `${item.year}.${item.month}`,
                            children: [{
                                title: '已分配',
                                dataIndex: 'planFte' + index,
                                key: 'planFte' + index,
                                width: 60,
                                render: text => text || 0,
                            }, {
                                title: '预分配',
                                dataIndex: 'prospectiveFte' + index,
                                key: 'prospectiveFte' + index,
                                width: 60,
                                render: text => text || 0,
                            }],
                        })
                    })
                }
            }
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (invList && invList.length > 0) {
                invList.map((item, index) => {
                    const addData = {};
                    if (item.userInvPlans && item.userInvPlans.length > 0) {
                        item.userInvPlans.map((planItem, planIndex) => {
                            addData['planFte' + planIndex] = planItem.planFte;
                            addData['prospectiveFte' + planIndex] = planItem.prospectiveFte;
                        })
                    }
                    dataSource.push({
                        index: index + 1,
                        ...item,
                        ...addData,
                    });
                });
            }
            return dataSource;
        };

        let x = 2580;
        if ((invList || []).length && (invList[0].userInvPlans || []).length) {
            x = 2580 + invList[0].userInvPlans.length * 2 * 60;
        }
    
        return (
            <Table
                rowKey={record => record.index}
                onChange={this.handleInvTableChange}
                columns={getColumns()}
                dataSource={getDataSource()}
                loading={invLoading}
                pagination={false}
                scroll={{ x, y: 240 }}
            />
        );
    }

    render() {
        const { data, loading, pagination, expandedRowKeys } = this.state;
        let x = 2680;
        if ((data || []).length && (data[0].userPlans || []).length) {
            x = 2680 + data[0].userPlans.length * 2 * 60;
        }
        return (
            <div className="content">
                <UserSider selectKey='userPlan' openKeys={['sub1']}/>
                <div className="main">
                    <Filter search={this.search} export={this.export} />
                    <Table
                        bordered
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.userId}
                        loading={loading} 
                        scroll={{ x }}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                        onExpand={this.onExpand}
                        expandedRowKeys={expandedRowKeys}
                        expandedRowRender={this.expandedRowRender}
                    />
                </div>            
            </div>
        );
    }
}

export default UserPlan;



// WEBPACK FOOTER //
// ./src/components/user/userPlan/index.js